import { render, staticRenderFns } from "./MendingMilestones.vue?vue&type=template&id=362d0934&scoped=true&"
import script from "./MendingMilestones.vue?vue&type=script&lang=js&"
export * from "./MendingMilestones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362d0934",
  null
  
)

export default component.exports